/**
 * CWC Mentors / Expert Reviewers.
 *
 * To add a new mentor: add an entry to this array.
 * Photos go in public/images/mentors/ — use a square crop for best results.
 * Keep topCerts to the 4-6 most impressive/relevant certifications.
 * The component will display these as chips.
 */

const mentors = [
  {
    id: 'robert-hibler',
    name: 'Robert Hibler',
    title: 'Senior Security Mentor',
    photo: '/images/mentors/Rob Hibler.PNG',
    bio: 'US Army veteran. 20+ years in cybersecurity across DOD, AWS, USAA, and Raytheon. Adjunct professor at Liberty University and UMGC. PhD candidate in Cybersecurity-GRC.',
    topCerts: ['CISSP', 'CCSP', 'CISM', 'CISA', 'CRISC', 'CASP+'],
    highlights: [
      '20+ years cybersecurity experience',
      'US Army veteran',
      'Former AWS & USAA senior security leader',
      'Adjunct professor at 2 universities',
      'PhD candidate, Cybersecurity-GRC',
      '80+ professional certifications',
    ],
    linkedin: 'https://www.linkedin.com/in/robert-hibler/',
    active: true,
  },
  {
    id: 'chad-freese',
    name: 'Chad Freese',
    title: 'Senior Security Mentor',
    photo: '/images/mentors/chad freese.jfif',
    bio: 'Retired U.S. Marine Corps Chief Warrant Officer 3 and former National Security Agency (NSA) Computer Network Exploitation Officer. Principal of IT/IS Risk Management at USAA. Former Principal Cybersecurity Architect and Red Team Lead at Honeywell Aerospace. Trusted leader in securing complex enterprise environments, with deep focus on application security, AI security, and enterprise GRC.',
    topCerts: ['CISSP', 'CCSP', 'CRISC', 'AIGP', 'CCZT', 'SecurityX', 'CEH', 'CTPRP'],
    highlights: [
      'Founder, CertNinjaPro',
      'Former NSA Computer Network Exploitation Officer',
      '20+ years leading cybersecurity, risk, and engineering programs',
      'Expertise in AI security, application security, and enterprise GRC',
      'Experience across financial services, defense, and aerospace',
      'MBA, IT Management',
      'MS, Cybersecurity',
      'BS, Computer Science / Network Security',
    ],
    active: true,
  },
  {
    id: 'caleb-king',
    name: 'Caleb King',
    title: 'AI & Engineering Mentor',
    photo: '/images/mentors/Caleb King.jfif',
    bio: 'Engineering leader and AI architect with 15+ years building production systems at scale. Founder of People In Tech (100K+ YouTube subscribers as TechDad). Former Director of Engineering at Forbes, Data & Analytics Technology Lead at USAA, and senior engineer at WebPT and Ticketmaster. MS Cybersecurity from Grand Canyon University (3.9 GPA).',
    topCerts: ['MS Cybersecurity', 'AI Architect', 'Google Cloud', 'AWS'],
    highlights: [
      '15+ years software engineering leadership',
      'Former Director of Engineering at Forbes',
      'Former Data & Analytics Lead at USAA',
      'Founder, People In Tech (100K+ YouTube)',
      'MS Cybersecurity, GCU (3.9 GPA)',
      'AI architecture consultant',
    ],
    active: true,
  },
  {
    id: 'chelsea-stevenson',
    name: 'Chelsea Stevenson',
    title: 'Risk & Compliance Mentor',
    photo: '/images/mentors/Chelsea Stevenson.jfif',
    bio: 'Information security and third-party risk specialist with a GRC and regulatory focus. Currently Manager of Risk and Compliance in Information Security at Progressive Insurance. Former Senior Information Security Advisor at USAA with 4+ years performing due diligence risk assessments for third-party suppliers. Juris Master in Cybersecurity, Privacy & Technology Risk Management from Florida State University College of Law.',
    topCerts: ['CISSP', 'CCSP', 'CTPRP', 'CySA+', 'PenTest+', 'Security+'],
    highlights: [
      'Manager of Risk & Compliance, Progressive Insurance',
      'Former Senior InfoSec Advisor at USAA (4+ yrs)',
      'Juris Master in Cybersecurity & Privacy Law (FSU)',
      'MBA (WGU), BS Cybersecurity & Info Assurance',
      'Third-party risk & regulatory compliance expert',
      'Privacy, GRC, and data protection specialist',
    ],
    active: true,
  },
  {
    id: 'karina-stippick',
    name: 'Karina Stippick',
    title: 'QA & Third-Party Risk Mentor',
    photo: '/images/mentors/Karina Stippick.jfif',
    bio: 'Cybersecurity and third-party risk professional with 10+ years across USAA, CSAA/AAA, and tribal government. Owner of Velocity Cyber-Mech. Conducted 500+ QA reviews of risk assessments at USAA. Deployed a $400K SIEM solution and led BC/DR planning for a major casino flooding event. MS Technology Leadership from UAT (Summa Cum Laude).',
    topCerts: ['Security+', 'CTPRP', 'CRVPM', 'AWS CP'],
    highlights: [
      '10+ years cybersecurity & risk experience',
      'USAA Senior InfoSec Advisor (5+ yrs)',
      'Former CSAA/AAA Cybersecurity Analyst',
      '500+ QA reviews of risk assessments',
      'Owner, Velocity Cyber-Mech',
      'MS Technology Leadership, UAT (Summa Cum Laude)',
    ],
    active: true,
  },
  {
    id: 'andrew-wise',
    name: 'Andrew Wise',
    title: 'Founder & Lead Mentor',
    photo: '/images/mentors/andrew-wise-headshot.jpg',
    bio: '20 years in enterprise security architecture, cloud security, and compliance. Current Director of Global IT, Security & Compliance. Former CSAA/AAA, USAA, Honeywell Aerospace. MS Cybersecurity from GCU (Summa Cum Laude). Founded CWC to bridge the gap between education and field experience.',
    topCerts: ['CISSP', 'CCSP', 'CEH', 'CTPRP'],
    highlights: [
      '20 years cybersecurity experience',
      'Director of Global IT, Security & Compliance',
      'Former USAA, Honeywell Aerospace, CSAA/AAA',
      'MS Cybersecurity, GCU (Summa Cum Laude)',
      'Cloud security architecture specialist',
      'FAA Commercial Helicopter Pilot',
      'CWC founder & president',
    ],
    linkedin: 'https://www.linkedin.com/in/awisepilot/',
    active: true,
  },
];

export const getActiveMentors = () => mentors.filter(m => m.active);
export default mentors;
